import NewPlacesSection from "./newPlacesSection";

export default NewPlacesSection;
